/**
 * "Kopiera länk" i shareSocialBlock, samt fokus i sökfältet.
 *
 * Ersätter FrontendSrc/patternlab/js/alz.js.
 */
const COPIED_TEXT = 'Länk kopierad!';
const FAILED_TEXT = 'Kunde inte kopiera länken. Kopiera den från adressfältet.';

/**
 * focusSearch anropas från inline-onclick i Views/Partials/Header.cshtml och
 * måste ligga på window - modulscope är inte globalt.
 *
 * Tilldelningen sker på modulnivå och inte i initShareLink(), som körs först i
 * jQuerys ready-callback. Originalet var en hissad funktionsdeklaration i ett
 * synkront skript och fanns så fort skriptet parsats; körs den här i en
 * ready-callback finns ett kort fönster där knappen är klickbar men funktionen
 * saknas, och ett klick där ger ReferenceError i inline-hanteraren.
 */
window.focusSearch = (): void => {
    // Fältet ligger i en Bootstrap-collapse och är inte fokuserbart förrän
    // utfällningen hunnit starta - därav fördröjningen från originalet.
    window.setTimeout(() => {
        document.querySelector<HTMLElement>('.search-focus-input')?.focus();
    }, 10);
};

async function copyToClipboard(text: string): Promise<boolean> {
    // execCommand('copy') i originalet är borttaget ur standarden. Clipboard API
    // kräver säker kontext, vilket sajten kör i.
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch {
        return false;
    }
}

export function initShareLink(): void {
    const button = document.getElementById('button-copy-url');
    if (!button) return;

    const output = document.querySelector<HTMLElement>('div.url-copy-output');

    button.addEventListener('click', async (e) => {
        e.preventDefault();
        const ok = await copyToClipboard(window.location.href);
        if (!output) return;

        // Även misslyckandet ska synas. Originalet visade alltid "kopierad",
        // oavsett utfall; att i stället visa ingenting vore värre - användaren
        // tror då att länken ligger i urklipp (WCAG 3.3.1).
        output.textContent = ok ? COPIED_TEXT : FAILED_TEXT;
        output.classList.toggle('alert-info', ok);
        output.classList.toggle('alert-warning', !ok);
        output.style.display = '';

        // Felmeddelandet ska hinna läsas och kräver en åtgärd av användaren.
        if (ok) {
            window.setTimeout(() => { output.style.display = 'none'; }, 2000);
        }
    });
}
